import container from "../../libs/container/container";

const amdHomeTopicsModule = (function () {
    const name = 'home__topics-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    };

    view.startup = function () {

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomeTopicsHeaderBigCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomeTopicsTopicCardInnerCls, 'animate__fadeInLeft25P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomeTopicsButtonContainerCls, 'animate__fadeInUp50P', name, {
            dynamicPosHeight: true
        });

        const topicBoxes = document.querySelectorAll(view.publicVars.cssId.anim.moduleHomeTopicsTopicBoxCls);

        for(let i = 1; i <= topicBoxes.length; i++) {
            container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleHomeTopicsTopicBoxCls + i, 'animate__zoomIn50P', name, {
                dynamicPosHeight: true
            });
        }
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdHomeTopicsModule;